<div class="vex-user-menu">
  <a
    (click)="openChangePassword()"
    class="vex-user-menu-item"
    matRipple
    matRippleColor="rgb(var(--vex-color-primary-600), 0.1)">
    <mat-icon
      class="vex-user-menu-item__icon icon-sm"
      svgIcon="mat:lock_reset"></mat-icon>
    <div class="vex-user-menu-item__label">Cambiar contraseña</div>
  </a>
  <a
    (click)="logout()"
    class="vex-user-menu-item"
    matRipple
    matRippleColor="rgb(var(--vex-color-primary-600), 0.1)">
    <mat-icon
      class="vex-user-menu-item__icon icon-sm"
      svgIcon="mat:logout"></mat-icon>
    <div class="vex-user-menu-item__label">Cerrar Sesión</div>
  </a>
</div>
